import { render, staticRenderFns } from "./BtnConsultaQualifCadastral.vue?vue&type=template&id=4bec564a&"
import script from "./BtnConsultaQualifCadastral.vue?vue&type=script&lang=js&"
export * from "./BtnConsultaQualifCadastral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports